"use client";

import React from "react";

//Styled
import * as S from "./styles";

//Icon
import { Star } from "lucide-react";

//Types
import { StartProps } from "@/types";

const Start: React.FC<StartProps> = ({ score }) => {
  return (
    <S.ScoreStar>
      <Star /> {score}
    </S.ScoreStar>
  );
};

export default Start;
